import './svg.scss';

import React from 'react';

export const CheckSVGIcon = () => (
  <svg
    className="check-svg-icon svg-icon"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M3.4,8.1l3.4,3.3L13,5.5l-1-0.9l-5.2,5L4.4,7.2L3.4,8.1z"
    />
  </svg>
);

export const CheckSVGIconFill = () => (
  <svg
    className="check-svg-icon svg-icon"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      d="M3.4,8.1l3.4,3.3L13,5.5l-1-0.9l-5.2,5L4.4,7.2L3.4,8.1z"
    />
  </svg>
);

export const CheckmarkSVGIcon = () => (
  <svg
    className="svg-icon"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      d="M6.2 9.25L3.8 6.75L2 8.625L6.2 13L14 4.875L12.2 3L6.2 9.25Z"
    />
  </svg>
);

export const ConfirmationCheckSVGIcon = () => (
  <svg className="confirmation-check-svg-icon svg-icon" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" d="M4.97451 7.40611L2.27451 4.59361L0.249512 6.70299L4.97451 11.6249L13.7495 2.48424L11.7245 0.374863L4.97451 7.40611Z" />
  </svg>
);

export const ConfirmationRejectSVGIcon = () => (
  <svg className="confirmation-reject-svg-icon svg-icon" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" d="M11.6011 2.30264C12.1268 1.77691 12.1268 0.924541 11.6011 0.398814C11.0754 -0.126913 10.223 -0.126913 9.69727 0.398814L5.99995 4.09613L2.29812 0.394295C1.77239 -0.131432 0.920021 -0.131432 0.394295 0.394295C-0.131432 0.920021 -0.131432 1.77239 0.394295 2.29812L4.09613 5.99995L0.398539 9.69754C-0.127187 10.2233 -0.127188 11.0756 0.398539 11.6014C0.924266 12.1271 1.77664 12.1271 2.30236 11.6014L5.99995 7.90378L9.70188 11.6057C10.2276 12.1314 11.08 12.1314 11.6057 11.6057C12.1314 11.08 12.1314 10.2276 11.6057 9.70188L7.90378 5.99995L11.6011 2.30264Z" />
  </svg>
);

export const InfoSVGIcon = () => (
  <svg
    className="info-svg-icon svg-icon"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00008 4.39323C6.46032 4.39323 6.83341 4.02013 6.83341 3.5599C6.83341 3.09966 6.46032 2.72656 6.00008 2.72656C5.53984 2.72656 5.16675 3.09966 5.16675 3.5599C5.16675 4.02013 5.53984 4.39323 6.00008 4.39323Z"
      className="fill"
    />
    <path
      d="M6.69331 5.84324V8.5899C6.69331 8.77379 6.62026 8.95014 6.49023 9.08016C6.36021 9.21019 6.18386 9.28324 5.99997 9.28324C5.81609 9.28324 5.63974 9.21019 5.50971 9.08016C5.37969 8.95014 5.30664 8.77379 5.30664 8.5899V5.84324C5.30664 5.65935 5.37969 5.483 5.50971 5.35298C5.63974 5.22295 5.81609 5.1499 5.99997 5.1499C6.18386 5.1499 6.36021 5.22295 6.49023 5.35298C6.62026 5.483 6.69331 5.65935 6.69331 5.84324V5.84324Z"
      className="fill"
    />
    <path
      d="M6 0C2.6864 0 0 2.6864 0 6C0 9.3136 2.6864 12 6 12C9.3136 12 12 9.3136 12 6C12 2.6864 9.3136 0 6 0ZM9.48827 9.48827C9.03161 9.95278 8.48747 10.3223 7.88727 10.5754C7.28707 10.8285 6.64268 10.9603 5.99129 10.963C5.3399 10.9658 4.69441 10.8396 4.09207 10.5916C3.48973 10.3436 2.94247 9.97874 2.48187 9.51813C2.02126 9.05753 1.65643 8.51027 1.40844 7.90793C1.16044 7.30559 1.03419 6.6601 1.03697 6.00871C1.03975 5.35732 1.1715 4.71293 1.42462 4.11273C1.67774 3.51253 2.04722 2.96839 2.51173 2.51173C2.96839 2.04722 3.51253 1.67774 4.11273 1.42462C4.71293 1.1715 5.35732 1.03975 6.00871 1.03697C6.6601 1.03419 7.30559 1.16044 7.90793 1.40844C8.51027 1.65643 9.05753 2.02126 9.51813 2.48187C9.97874 2.94247 10.3436 3.48973 10.5916 4.09207C10.8396 4.69441 10.9658 5.3399 10.963 5.99129C10.9603 6.64268 10.8285 7.28707 10.5754 7.88727C10.3223 8.48747 9.95278 9.03161 9.48827 9.48827V9.48827Z"
      className="fill"
    />
    <path
      d="M6 0C2.6864 0 0 2.6864 0 6C0 9.3136 2.6864 12 6 12C9.3136 12 12 9.3136 12 6C12 2.6864 9.3136 0 6 0ZM9.48827 9.48827C9.03161 9.95278 8.48747 10.3223 7.88727 10.5754C7.28707 10.8285 6.64268 10.9603 5.99129 10.963C5.3399 10.9658 4.69441 10.8396 4.09207 10.5916C3.48973 10.3436 2.94247 9.97874 2.48187 9.51813C2.02126 9.05753 1.65643 8.51027 1.40844 7.90793C1.16044 7.30559 1.03419 6.6601 1.03697 6.00871C1.03975 5.35732 1.1715 4.71293 1.42462 4.11273C1.67774 3.51253 2.04722 2.96839 2.51173 2.51173C2.96839 2.04722 3.51253 1.67774 4.11273 1.42462C4.71293 1.1715 5.35732 1.03975 6.00871 1.03697C6.6601 1.03419 7.30559 1.16044 7.90793 1.40844C8.51027 1.65643 9.05753 2.02126 9.51813 2.48187C9.97874 2.94247 10.3436 3.48973 10.5916 4.09207C10.8396 4.69441 10.9658 5.3399 10.963 5.99129C10.9603 6.64268 10.8285 7.28707 10.5754 7.88727C10.3223 8.48747 9.95278 9.03161 9.48827 9.48827V9.48827Z"
      className="fill"
    />
  </svg>
);

export const HelpSVGIcon = () => {
  return (
    <svg
      className="help-svg-icon svg-icon"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.58505 11.1615H7.59336C8.09929 11.1615 8.51198 10.7537 8.51567 10.2451L8.51936 9.82805C8.58953 9.2373 9.0036 8.82807 9.66602 8.21607C9.93191 7.97081 10.2066 7.71677 10.4637 7.42671C11.3892 6.38193 11.5651 5.0032 10.923 3.82816C10.1516 2.41711 8.39473 1.71181 6.65028 2.11041C5.35406 2.40741 4.39943 3.36582 4.03152 4.74085C3.89996 5.23368 4.19217 5.74037 4.68471 5.87247C5.17726 6.0041 5.68365 5.71173 5.81567 5.2189C5.92461 4.81244 6.23113 4.1016 7.06296 3.9113C7.85925 3.72886 8.88404 3.94641 9.30365 4.71498C9.66787 5.38056 9.32165 5.93205 9.083 6.20133C8.88974 6.41978 8.66319 6.62922 8.42377 6.85056L8.41458 6.85905C7.69768 7.52093 6.8063 8.34448 6.67844 9.6881C6.67567 9.71443 6.67428 9.74122 6.67428 9.76754L6.67013 10.2294C6.66551 10.7398 7.07543 11.1569 7.58505 11.1615ZM6.94201 13.6631C7.11281 13.834 7.35285 13.931 7.59289 13.931C7.83755 13.931 8.07298 13.834 8.24839 13.6631C8.41919 13.4876 8.51613 13.252 8.51613 13.0072C8.51613 12.767 8.41919 12.5269 8.24377 12.356C7.90218 12.0142 7.28361 12.0142 6.94201 12.356C6.7666 12.5269 6.66966 12.767 6.66966 13.0072C6.66966 13.252 6.7666 13.4922 6.94201 13.6631Z"
      />
    </svg>
  );
};

export const HelpSVGIconCircle = () => (
  <svg
    className="tutorial-svg-icon svg-icon"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389954 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948211 11.387 0 9 0V0ZM9.9702 13.4712C9.9702 13.5743 9.92924 13.6732 9.85633 13.7461C9.78341 13.819 9.68452 13.86 9.5814 13.86H8.0766C7.97349 13.86 7.87459 13.819 7.80168 13.7461C7.72877 13.6732 7.6878 13.5743 7.6878 13.4712V12.2112C7.6878 12.1081 7.72877 12.0092 7.80168 11.9363C7.87459 11.8634 7.97349 11.8224 8.0766 11.8224H9.5814C9.68452 11.8224 9.78341 11.8634 9.85633 11.9363C9.92924 12.0092 9.9702 12.1081 9.9702 12.2112V13.4712ZM11.3814 8.8938C11.1762 9.0396 10.9512 9.1584 10.737 9.2952C10.377 9.5274 10.08 9.8154 10.017 10.2726C9.9936 10.4292 9.8748 10.4904 9.7218 10.4904H8.8758C8.6004 10.4904 8.3268 10.4904 8.0514 10.4904C7.8228 10.4904 7.7418 10.3896 7.7202 10.1664C7.6356 9.333 8.0622 8.7714 8.6886 8.316C8.8686 8.181 9.0864 8.0784 9.2844 7.956C9.44702 7.87255 9.60343 7.7775 9.7524 7.6716C9.84508 7.60323 9.92001 7.51363 9.9709 7.41032C10.0218 7.307 10.0472 7.19299 10.0449 7.07784C10.0426 6.9627 10.0127 6.84978 9.95773 6.74857C9.90277 6.64737 9.82433 6.56082 9.729 6.4962C9.46778 6.30154 9.14588 6.20607 8.82077 6.22684C8.49566 6.24761 8.18852 6.38328 7.9542 6.6096C7.749 6.8184 7.56 7.0434 7.38 7.2648C7.35978 7.30029 7.33156 7.33058 7.29758 7.35326C7.2636 7.37594 7.22481 7.39038 7.18427 7.39545C7.14374 7.40052 7.10258 7.39607 7.06406 7.38245C7.02555 7.36883 6.99074 7.34642 6.9624 7.317L5.8518 6.498C5.625 6.3306 5.607 6.2424 5.7582 5.9976C6.3324 5.0688 7.1208 4.4388 8.2098 4.2246C9.4482 3.9798 10.5498 4.2642 11.4642 5.1336C11.7181 5.35349 11.9259 5.62145 12.0758 5.92204C12.2256 6.22263 12.3144 6.54991 12.3372 6.885C12.371 7.27459 12.3002 7.66614 12.1322 8.01926C11.9642 8.37238 11.705 8.67427 11.3814 8.8938Z" />
  </svg>
)

/** Lock Icon from Orion Icon Library - https://orioniconlibrary.com/icon/lock-1445 */

export const NotificationBellSVGIcon = () => {
  return (
    <svg
      className="notification-bell-svg-icon svg-icon"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg">
      <circle className="circle" opacity="0.5" cx="20" cy="20" r="20" />
      <path
        className="stroke"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5008 21.7871V21.5681C11.533 20.9202 11.7406 20.2925 12.1024 19.7496C12.7045 19.0975 13.1167 18.2983 13.2957 17.436C13.2957 16.7695 13.2957 16.0935 13.3539 15.427C13.6547 12.2184 16.8273 10 19.9611 10H20.0387C23.1725 10 26.345 12.2184 26.6555 15.427C26.7137 16.0935 26.6555 16.7695 26.704 17.436C26.8854 18.3003 27.2972 19.1019 27.8974 19.7591C28.2618 20.2972 28.4698 20.9227 28.4989 21.5681V21.7776C28.5206 22.648 28.2208 23.4968 27.6548 24.1674C26.907 24.9515 25.8921 25.4393 24.8024 25.5384C21.607 25.8812 18.383 25.8812 15.1876 25.5384C14.0991 25.435 13.0858 24.9479 12.3352 24.1674C11.778 23.4963 11.4822 22.6526 11.5008 21.7871Z"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="stroke"
        d="M17.5552 28.8518C18.0545 29.4785 18.7876 29.884 19.5925 29.9788C20.3973 30.0735 21.2074 29.8495 21.8435 29.3564C22.0391 29.2106 22.2152 29.041 22.3674 28.8518"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationMessageCheckSVGIcon = () => {
  return (
    <svg
      className="notification-message-check-svg-icon svg-icon"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        d="M5.425 8.09375L3.325 5.90625L1.75 7.54688L5.425 11.375L12.25 4.26563L10.675 2.625L5.425 8.09375Z"
        fill="white"
      />
    </svg>
  );
};

export const NotificationMessageErrorSVGIcon = () => {
  return (
    <svg
      className="notification-message-error-svg-icon svg-icon"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        d="M13.7826 9.42383L8.13423 0.619406C7.60331 -0.206469 6.40874 -0.206469 5.87782 0.619406L0.214675 9.42383C-0.360489 10.3234 0.288413 11.4885 1.35025 11.4885H12.6765C13.7236 11.4885 14.3578 10.3234 13.7826 9.42383ZM9.04859 8.43573C9.2993 8.68644 9.2993 9.09938 9.04859 9.36484C8.91586 9.49757 8.75364 9.55656 8.59141 9.55656C8.42918 9.55656 8.25221 9.49757 8.13423 9.36484L6.99865 8.22926L5.86307 9.36484C5.73034 9.49757 5.56812 9.55656 5.40589 9.55656C5.24367 9.55656 5.06669 9.49757 4.94871 9.36484C4.698 9.11412 4.698 8.70119 4.94871 8.43573L6.08429 7.30015L4.94871 6.16457C4.698 5.91386 4.698 5.50092 4.94871 5.23546C5.19942 4.98475 5.61236 4.98475 5.87782 5.23546L7.0134 6.37104L8.14898 5.23546C8.39969 4.98475 8.81263 4.98475 9.07809 5.23546C9.3288 5.48617 9.3288 5.89911 9.07809 6.16457L7.94251 7.30015L9.04859 8.43573Z"
      />
    </svg>
  );
};

export const NotificationMessageWarningSVGIcon = () => {
  return (
    <svg
      className="notification-message-warning-svg-icon svg-icon"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        d="M13.7966 10.5926L8.02243 0.59122C7.81111 0.225339 7.42074 0 6.99827 0C6.5758 0 6.18543 0.225339 5.97411 0.59122L0.158362 10.6646C-0.0527875 11.0305 -0.0527875 11.4812 0.158362 11.847C0.369681 12.2129 0.760055 12.4383 1.18252 12.4383H12.8142H12.8176C13.4706 12.4383 14 11.9089 14 11.2558C13.9998 11.01 13.925 10.7817 13.7966 10.5926ZM6.99996 3.47874C7.36482 3.47874 7.66077 3.77452 7.66077 4.13955L7.49185 8.08062C7.47496 8.43705 7.19793 8.57252 6.99996 8.57252C6.77817 8.57252 6.52749 8.45563 6.50806 8.08062L6.33914 4.13955C6.33914 3.77452 6.63509 3.47874 6.99996 3.47874ZM7.59624 10.5705C7.44067 10.7276 7.22276 10.8171 6.99996 10.8171C6.77698 10.8171 6.55908 10.7276 6.40198 10.5705C6.24489 10.4134 6.15536 10.1955 6.15536 9.97253C6.15536 9.74955 6.24489 9.53334 6.40198 9.37624C6.55908 9.21914 6.77698 9.12793 6.99996 9.12793C7.22276 9.12793 7.44067 9.21914 7.59624 9.37624C7.75503 9.53334 7.84456 9.75124 7.84456 9.97253C7.84456 10.1955 7.75503 10.4134 7.59624 10.5705Z"
      />
    </svg>
  );
};

export const NotificationCloseSVGIcon = () => {
  return (
    <svg
      className="notification-close-svg-icon svg-icon"
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        d="M1.20711 11.1065C0.816583 11.497 0.816583 12.1301 1.20711 12.5207C1.59763 12.9112 2.2308 12.9112 2.62132 12.5207L6.86377 8.27821L11.1065 12.5209C11.497 12.9114 12.1301 12.9114 12.5207 12.5209C12.9112 12.1304 12.9112 11.4972 12.5207 11.1067L8.27798 6.864L12.5208 2.62117C12.9113 2.23064 12.9113 1.59748 12.5208 1.20696C12.1303 0.816431 11.4971 0.816431 11.1066 1.20696L6.86377 5.44979L2.62117 1.20719C2.23064 0.816663 1.59748 0.816663 1.20696 1.20719C0.816431 1.59771 0.816431 2.23088 1.20696 2.6214L5.44956 6.864L1.20711 11.1065Z"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export const TextInputErrorSVGIcon = () => {
  return (
    <svg
      className="text-input-error-svg-icon svg-icon"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#F23F3F" />
      <path
        className="fill"
        d="M12.5217 9.61605L8.75607 3.74643C8.40212 3.19585 7.60574 3.19585 7.2518 3.74643L3.47637 9.61605C3.09293 10.2158 3.52553 10.9925 4.23342 10.9925H11.7843C12.4823 10.9925 12.9051 10.2158 12.5217 9.61605ZM9.36565 8.95731C9.53279 9.12445 9.53279 9.39975 9.36565 9.57672C9.27716 9.66521 9.16901 9.70453 9.06086 9.70453C8.95271 9.70453 8.83473 9.66521 8.75607 9.57672L7.99902 8.81967L7.24197 9.57672C7.15348 9.66521 7.04533 9.70453 6.93718 9.70453C6.82903 9.70453 6.71105 9.66521 6.63239 9.57672C6.46525 9.40958 6.46525 9.13429 6.63239 8.95731L7.38944 8.20026L6.63239 7.44321C6.46525 7.27607 6.46525 7.00078 6.63239 6.8238C6.79953 6.65666 7.07483 6.65666 7.2518 6.8238L8.00885 7.58085L8.7659 6.8238C8.93304 6.65666 9.20834 6.65666 9.38531 6.8238C9.55245 6.99094 9.55245 7.26624 9.38531 7.44321L8.62826 8.20026L9.36565 8.95731Z"
      />
    </svg>
  );
};

export const TextInputSuccessSVGIcon = () => {
  return (
    <svg
      className="text-input-success-svg-icon svg-icon"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#7FBA7A" />
      <path
        className="fill"
        d="M6.95 8.72933L5.55 7.271L4.5 8.36475L6.95 10.9168L11.5 6.17725L10.45 5.0835L6.95 8.72933Z"
      />
    </svg>
  );
};

export const TextInputWarningSVGIcon = () => {
  return (
    <svg
      className="text-input-warning-svg-icon svg-icon"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#FFBE0B" />
      <path
        fill="white"
        d="M12.531 10.3952L8.68154 3.72764C8.54066 3.48372 8.28041 3.3335 7.99876 3.3335C7.71712 3.3335 7.45687 3.48372 7.31599 3.72764L3.43883 10.4432C3.29806 10.6871 3.29806 10.9876 3.43883 11.2315C3.57971 11.4754 3.83996 11.6257 4.1216 11.6257H11.876H11.8783C12.3137 11.6257 12.6666 11.2727 12.6666 10.8374C12.6665 10.6735 12.6166 10.5213 12.531 10.3952ZM7.99989 5.65265C8.24313 5.65265 8.44043 5.84984 8.44043 6.0932L8.32782 8.72058C8.31656 8.95819 8.13187 9.04851 7.99989 9.04851C7.85203 9.04851 7.68491 8.97058 7.67196 8.72058L7.55935 6.0932C7.55935 5.84984 7.75665 5.65265 7.99989 5.65265ZM8.39741 10.3805C8.2937 10.4852 8.14843 10.5449 7.99989 10.5449C7.85124 10.5449 7.70597 10.4852 7.60124 10.3805C7.49651 10.2758 7.43682 10.1305 7.43682 9.98185C7.43682 9.8332 7.49651 9.68905 7.60124 9.58432C7.70597 9.47959 7.85124 9.41878 7.99989 9.41878C8.14843 9.41878 8.2937 9.47959 8.39741 9.58432C8.50327 9.68905 8.56296 9.83432 8.56296 9.98185C8.56296 10.1305 8.50327 10.2758 8.39741 10.3805Z"
      />
    </svg>
  );
};

export const NetworkErrorIcon = () => {
  return (
    <svg
      className="network-error-svg-icon svg-icon"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        d="M55.3004 26.2955C55.1678 26.441 55.0062 26.5572 54.826 26.6365C54.6459 26.7159 54.4511 26.7566 54.2542 26.7562C53.8967 26.7479 53.5549 26.6078 53.2945 26.3627C47.4897 20.9116 39.8259 17.8773 31.8629 17.8773C23.8999 17.8773 16.2361 20.9116 10.4314 26.3627C10.1526 26.6249 9.78119 26.7656 9.39871 26.7539C9.01623 26.7422 8.65406 26.579 8.39188 26.3003C8.1297 26.0216 7.98898 25.6501 8.00068 25.2676C8.01237 24.8851 8.17553 24.523 8.45426 24.2608C14.7968 18.3113 23.1667 15 31.8629 15C40.5591 15 48.9291 18.3113 55.2716 24.2608C55.545 24.5269 55.7017 24.8907 55.7071 25.2722C55.7124 25.6537 55.5662 26.0218 55.3004 26.2955ZM45.8755 29.002C41.227 25.7659 35.6032 24.2352 29.9559 24.6689C24.3085 25.1027 18.9845 27.4742 14.8847 31.3822C14.6803 31.5791 14.5386 31.8319 14.4774 32.109C14.4163 32.386 14.4383 32.675 14.5409 32.9396C14.6434 33.2042 14.8219 33.4326 15.0538 33.596C15.2857 33.7595 15.5608 33.8508 15.8444 33.8584C16.2023 33.852 16.5448 33.7116 16.8042 33.4649C20.4206 30.0154 25.1182 27.9218 30.1013 27.5387C35.0844 27.1557 40.0467 28.5067 44.1479 31.3631C44.461 31.582 44.8482 31.6675 45.2244 31.6009C45.6006 31.5343 45.9349 31.321 46.1538 31.0079C46.3727 30.6948 46.4583 30.3076 46.3917 29.9314C46.3251 29.5553 46.1118 29.2209 45.7987 29.002H45.8755ZM31.8341 34.1944C27.9069 34.1822 24.1336 35.7205 21.3343 38.4749C21.1988 38.6072 21.0907 38.765 21.0162 38.9391C20.9416 39.1132 20.9021 39.3003 20.8999 39.4897C20.8977 39.6791 20.9328 39.867 21.0032 40.0429C21.0736 40.2187 21.178 40.3789 21.3103 40.5144C21.4426 40.6499 21.6004 40.758 21.7745 40.8325C21.9486 40.9071 22.1357 40.9466 22.3251 40.9488C22.5145 40.951 22.7024 40.9159 22.8783 40.8455C23.0541 40.7751 23.2143 40.6707 23.3498 40.5384C25.6156 38.3179 28.6617 37.0742 31.8341 37.0742C35.0066 37.0742 38.0526 38.3179 40.3184 40.5384C40.5764 40.7897 40.9183 40.9367 41.2782 40.9511C41.484 40.9642 41.6902 40.9324 41.8825 40.8578C42.0747 40.7832 42.2484 40.6677 42.3915 40.5192C42.6617 40.2476 42.8134 39.8801 42.8134 39.4971C42.8134 39.114 42.6617 38.7465 42.3915 38.4749C39.578 35.7064 35.7812 34.167 31.8341 34.1944ZM31.8341 43.792C31.0477 43.7905 30.2705 43.9617 29.5574 44.2933C28.8443 44.625 28.2127 45.1091 27.7071 45.7115C27.5002 46.0075 27.4122 46.3705 27.4604 46.7284C27.5086 47.0863 27.6896 47.4131 27.9674 47.6438C28.2452 47.8745 28.5996 47.9924 28.9603 47.974C29.321 47.9557 29.6616 47.8024 29.9146 47.5447C30.1533 47.27 30.4482 47.0498 30.7794 46.8989C31.1105 46.748 31.4702 46.6699 31.8341 46.6699C32.198 46.6699 32.5577 46.748 32.8889 46.8989C33.22 47.0498 33.5149 47.27 33.7537 47.5447C33.8898 47.7043 34.0591 47.8325 34.2496 47.9203C34.4402 48.0081 34.6476 48.0535 34.8574 48.0534C35.2077 48.0628 35.5492 47.9432 35.8171 47.7174C36.108 47.4714 36.2895 47.1202 36.3219 46.7406C36.3543 46.361 36.2349 45.9841 35.9899 45.6923C35.4794 45.0897 34.8423 44.607 34.124 44.2785C33.4057 43.9501 32.6239 43.7839 31.8341 43.792Z"
      />
      <path
        className="fill"
        d="M48 46.3389C47.9999 45.9543 48.1517 45.5852 48.4223 45.3119C48.6991 45.0556 49.0624 44.9132 49.4396 44.9132C49.8169 44.9132 50.1802 45.0556 50.457 45.3119C50.7276 45.5852 50.8794 45.9543 50.8793 46.3389C50.8764 46.575 50.8159 46.8069 50.703 47.0143C50.5901 47.2218 50.4282 47.3984 50.2314 47.529C50.0346 47.6596 49.8089 47.7401 49.5738 47.7635C49.3388 47.7869 49.1017 47.7525 48.883 47.6634C48.7073 47.5943 48.5497 47.486 48.4223 47.3466C48.2889 47.2149 48.1829 47.0579 48.1104 46.885C48.0379 46.712 48.0004 46.5264 48 46.3389Z"
      />
      <path
        className="fill"
        d="M48.4217 32.4217C48.6916 32.1517 49.0578 32 49.4396 32C49.8215 32 50.1876 32.1517 50.4576 32.4217C50.7276 32.6916 50.8793 33.0578 50.8793 33.4396V41.7992C50.8793 42.181 50.7276 42.5472 50.4576 42.8172C50.1876 43.0872 49.8215 43.2388 49.4396 43.2388C49.0578 43.2388 48.6916 43.0872 48.4217 42.8172C48.1517 42.5472 48 42.181 48 41.7992V33.4396C48 33.0578 48.1517 32.6916 48.4217 32.4217Z"
      />
    </svg>
  );
};

export const IngestingSVGIcon = () => (
  <svg
    className="ingesting-svg-icon svg-icon"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6 5.6C17.6 5.71598 17.5952 5.83117 17.588 5.94559C19.0432 6.5752 20 8.00641 20 9.6C20 11.8056 18.2056 13.6 16 13.6H12.4C12.1792 13.6 12 13.4208 12 13.2C12 12.9792 12.1792 12.8 12.4 12.8H16C17.7648 12.8 19.2 11.3648 19.2 9.6C19.2 8.24238 18.3288 7.03199 17.032 6.58719C16.8536 6.52637 16.7424 6.34957 16.764 6.16238C16.7856 5.97762 16.8 5.79039 16.8 5.6C16.8 2.95281 14.6472 0.8 12 0.8C9.96879 0.8 8.15039 2.09039 7.47602 4.01043C7.43762 4.11922 7.35359 4.20723 7.24641 4.24961C7.13762 4.29203 7.0168 4.28723 6.91441 4.23281C6.61602 4.0784 6.30801 4 6 4C4.89762 4 4 4.89762 4 6C4 6.20402 3.85039 6.41523 3.64801 6.43762C2.02398 6.6168 0.8 7.9768 0.8 9.6C0.8 11.3648 2.2352 12.8 4 12.8H7.6C7.82078 12.8 8 12.9792 8 13.2C8 13.4208 7.82078 13.6 7.6 13.6H4C1.79441 13.6 0 11.8056 0 9.6C0 7.68238 1.36398 6.05922 3.2232 5.69359C3.38719 4.2768 4.57039 3.2 6 3.2C6.29684 3.2 6.59043 3.25039 6.87762 3.34879C7.7648 1.32961 9.77281 0 12 0C15.0872 0 17.6 2.51199 17.6 5.6ZM9.9998 7.19971C9.90321 7.19971 9.81456 7.23389 9.74543 7.29126C9.73292 7.30164 9.72087 7.31262 9.70973 7.32422L6.51744 10.517C6.44572 10.5884 6.40696 10.6805 6.40117 10.7745C6.3943 10.885 6.43306 10.9979 6.51744 11.0822C6.67338 11.2384 6.92698 11.2384 7.08293 11.0822L9.59986 8.56506L9.59987 19.5996C9.59987 19.6808 9.62413 19.7565 9.66563 19.8193C9.7372 19.928 9.86018 20 9.9998 20C10.2206 20 10.3999 19.8206 10.3999 19.5996L10.3999 8.56567L12.9167 11.0834C12.9949 11.1609 13.0973 11.2 13.1999 11.2C13.3023 11.2 13.4046 11.1609 13.4831 11.0822C13.639 10.9265 13.639 10.6726 13.4831 10.517L10.283 7.3169C10.2105 7.24426 10.1101 7.19971 9.9998 7.19971Z"
    />
  </svg>
);

export const VisibleOnSVGIcon = () => (
  <svg
    className="visible-on-svg-icon svg-icon"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 3.74512C6.14757 3.74512 2.87901 6.35765 1.6626 9.99826C2.87901 13.6389 6.14757 16.2514 10.0001 16.2514C13.8526 16.2514 17.1212 13.6388 18.3376 9.99826C17.1212 6.35765 13.8526 3.74512 10.0001 3.74512ZM10.0001 14.167C7.69774 14.167 5.83135 12.3006 5.83135 9.99826C5.83135 7.6959 7.69774 5.82951 10.0001 5.82951C12.3025 5.82951 14.1688 7.6959 14.1688 9.99826C14.1688 12.3005 12.3025 14.167 10.0001 14.167ZM8.52622 11.4721C9.34022 12.2861 10.66 12.2861 11.474 11.4721C12.288 10.6581 12.288 9.33838 11.474 8.52439C10.66 7.71039 9.34022 7.71039 8.52622 8.52439C7.71223 9.33838 7.71223 10.6581 8.52622 11.4721Z"
    />
  </svg>
);

export const VisibleOffSVGIcon = () => (
  <svg
    className="visible-off-svg-icon svg-icon"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.293 2.707L2 2L14 14L13.293 14.707L10.951 12.365C10.039 12.77 9.042 13 8 13C4.838 13 2.026 10.991 1 8C1.454 6.676 2.276 5.568 3.308 4.722L1.293 2.707ZM5 8C5 9.657 6.343 11 8 11C8.462 11 8.895 10.887 9.286 10.7L8.511 9.925C8.347 9.969 8.178 10 8 10C6.897 10 6 9.103 6 8C6 7.822 6.031 7.653 6.075 7.489L5.3 6.714C5.113 7.105 5 7.538 5 8ZM8.00001 5C9.65701 5 11 6.343 11 8C11 8.462 10.887 8.895 10.7 9.286L12.701 11.287C13.73 10.437 14.546 9.323 15 8C13.974 5.009 11.162 3 8.00001 3C6.95901 3 5.96401 3.236 5.04901 3.635L6.71401 5.3C7.10501 5.113 7.53801 5 8.00001 5ZM7.48901 6.075L9.92601 8.512C9.96901 8.347 10 8.178 10 8C10 6.897 9.10301 6 8.00001 6C7.82201 6 7.65301 6.031 7.48901 6.075Z"
    />
  </svg>
);

export const LockSVGIcon = () => (
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className="lock-svg-icon svg-icon">
    <path className="stroke" d="M19 30V15A13 13 0 0 1 32 2a13 13 0 0 1 13 13v15" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    <path className="stroke" d="M32 41v10" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    <rect className="stroke" x="10" y="30" width="44" height="32" rx="6" ry="6" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
  </svg>
)
